import { HeaderStyled, CustomerInfo } from "./styles";

import useAuth from "../../hooks/useAuth";

export default function HeaderAuth() {
  const { user, onLogout } = useAuth();

  const handleLogout = () => {
    onLogout();
  };

  const data = new Date();
  const diaSemana = String(data.getDay())
    .replace("0", "Domingo")
    .replace("1", "Segunda")
    .replace("2", "Terça")
    .replace("3", "Quarta")
    .replace("4", "Quinta")
    .replace("5", "Sexta")
    .replace("6", "Sábado");
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();
  const dataAtual = diaSemana + ", " + dia + "/" + mes + "/" + ano;

  return (
    <HeaderStyled>
      <CustomerInfo>
        <p>
          Olá, {user?.name}! <br />
          {dataAtual}
        </p>
      </CustomerInfo>
      <button onClick={handleLogout}>Sair</button>
    </HeaderStyled>
  );
}
